import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import ProductCategoriesTableRow from "./ProductCategoriesTableRow";

const ProductCategoriesTable = ({ productCategories, handleUpdateProductCategoryChangeList, handleConfirmCategoryDeletion }) => {
  const [localProductCategories, setLocalProductCategories] =
    useState(productCategories);

  useEffect(() => {
    setLocalProductCategories(productCategories);
  }, [productCategories]);

  const handleUpdateLocalProductCategory = (field, value, productCategoryId) => {
    let _productCategory = localProductCategories.find((p) => p.id === productCategoryId);
    if (_productCategory) {
        _productCategory = { ..._productCategory, [field]: value };
      setLocalProductCategories(
        localProductCategories.map((p) => (p.id === productCategoryId ? _productCategory : p))
      );
      handleUpdateProductCategoryChangeList(_productCategory);
    }
  };

  return <div
  className="products-table-container-wrapper"
>
  <Typography className="products-table-heading">
    Product Categories
  </Typography>
  <Table size="small">
    <TableHead>
      <TableRow>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 200 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Name
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 200 }}
        >
          <Typography
            variant="caption"
            className="products-table-header"
          >
            Default Colour
          </Typography>
        </TableCell>
        <TableCell
          className="products-table-header-cell"
          style={{ width: 30 }}
        >
          
        </TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {localProductCategories
        .map((productCategory, index) => (
          <ProductCategoriesTableRow
            key={index}
            index={index}
            productCategory={productCategory}
            handleConfirmCategoryDeletion={handleConfirmCategoryDeletion}
            handleUpdateLocalProductCategory={handleUpdateLocalProductCategory}
          />
        ))}
    </TableBody>
  </Table>
</div>;
};

export default ProductCategoriesTable;
